import { CrossFillIcon, LeftArrow2Icon } from '../../utils/SVGIcon';
import cn from '../../utils/cn';

function Arrow({ setShow }) {
    return (
        <button
            type="button"
            className="w-11 h-11 py-2 flex justify-center bg-[#f3f3f5] fixed bottom-3 xl:bottom-auto lg:top-[70px] right-0 z-10 rounded-tl-10 rounded-bl-10 transition-all duration-[400ms]"
            onClick={() => setShow((prev) => !prev)}
        >
            <div className="w-7">
                <LeftArrow2Icon className="rotate-90 lg:rotate-0 opacity-85" />
                {/* {show ? <CrossFillIcon /> : <LeftArrow2Icon />} */}
            </div>
        </button>
    );
}

function SidebarMenu({ setShow }) {
    return (
        <div className="w-full lg:w-[66px] h-[66px] lg:h-full bg-[#f3f3f5] flex flex-col items-end justify-center lg:justify-start lg:items-center relative">
            <button
                type="button"
                className="h-auto lg:h-13 w-11 lg:w-9 flex justify-center lg:mr-0"
                onClick={() => setShow((prev) => !prev)}
            >
                <CrossFillIcon className="hidden lg:block" />
                <div className="w-7 block lg:hidden">
                    <LeftArrow2Icon className=" -rotate-90 lg:rotate-0 opacity-85" />
                </div>
            </button>
        </div>
    );
}

function SidebarContent({ children }) {
    return (
        <div className="w-full h-full overflow-hidden">
            <div className="p-5 h-full overflow-y-auto">{children}</div>
        </div>
    );
}

function InfoSidebar({ children, show, setShow, className = '' }) {
    return (
        <div>
            <div
                className={cn(
                    `flex flex-col lg:flex-row w-full h-full transition-all duration-[400ms] ease-linear fixed  lg:top-[70px] z-20 bg-white`,
                    className,
                    {
                        'right-0 top-[70px]': show,
                        'top-full right-0 lg:-right-full': !show
                    }
                )}
            >
                <SidebarMenu setShow={setShow} />
                <SidebarContent>{children}</SidebarContent>
            </div>

            <Arrow setShow={setShow} />
        </div>
    );
}

export default InfoSidebar;
